import { render, staticRenderFns } from "./ExpressionAnswerForm.vue?vue&type=template&id=3f795e24&scoped=true&"
import script from "./ExpressionAnswerForm.vue?vue&type=script&lang=js&"
export * from "./ExpressionAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./ExpressionAnswerForm.vue?vue&type=style&index=0&id=3f795e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f795e24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VDialog,VProgressCircular})
